import { List } from '@phosphor-icons/react';

export default List;
